import { defineMessages } from 'react-intl'

const baseId = 'chats'

export default defineMessages({
  title: {
    id: `${baseId}.title`,
    defaultMessage: 'Chats',
  },
  column_chat_id: {
    id: `${baseId}.column_chat_id`,
    defaultMessage: 'Chat Channel ID',
  },
  column_date_created: {
    id: `${baseId}.column_date_created`,
    defaultMessage: 'Date Created',
  },
  column_last_clinician_message_time: {
    id: `${baseId}.column_last_clinician_message_time`,
    defaultMessage: "Clinician's Last Message",
  },
  column_patient_first_name: {
    id: `${baseId}.column_patient_first_name`,
    defaultMessage: 'Patient First Name',
  },
  column_patient_last_name: {
    id: `${baseId}.column_patient_last_name`,
    defaultMessage: 'Patient Last Name',
  },
  column_clinician_name: {
    id: `${baseId}.column_clinician_name`,
    defaultMessage: 'Consultant',
  },
  column_status: {
    id: `${baseId}.column_status`,
    defaultMessage: 'Chat State',
  },
  status_all: {
    id: `${baseId}.status_all`,
    defaultMessage: 'All',
  },
  status_active: {
    id: `${baseId}.status_active`,
    defaultMessage: 'Active',
  },
  status_closed: {
    id: `${baseId}.status_closed`,
    defaultMessage: 'Closed',
  },
  column_time_from_last_clinician_message: {
    id: `${baseId}.column_time_from_last_clinician_message`,
    defaultMessage: 'Days since last clinician message',
  },
  column_last_patient_message_time: {
    id: `${baseId}.column_last_patient_message_time`,
    defaultMessage: "Patient's Last Message",
  },
  reassign_button: {
    id: `${baseId}.reassign_button`,
    defaultMessage: 'Reassign',
  },
  search_button: {
    id: `${baseId}.search_button`,
    defaultMessage: 'Search',
  },
  reset_button: {
    id: `${baseId}.reset_button`,
    defaultMessage: 'Reset',
  },
  error_loading_chats: {
    id: `${baseId}.error_loading_chats`,
    defaultMessage: 'Error loading chats',
  },
  no_results_found: {
    id: `${baseId}.no_results_found`,
    defaultMessage: 'No results found',
  },
  copy_chat_id: {
    id: `${baseId}.copy_chat_id`,
    defaultMessage: 'Copy Chat ID',
  },
  reassign_dialog_title: {
    id: `${baseId}.reassign_dialog_title`,
    defaultMessage: 'Confirm Reassignment',
  },
  reassign_dialog_body: {
    id: `${baseId}.reassign_dialog_body`,
    defaultMessage:
      'Are you sure you want to reassign this consultation?\nThis action cannot be undone.',
  },
  reassign_dialog_cancel: {
    id: `${baseId}.reassign_dialog_cancel`,
    defaultMessage: 'Cancel',
  },
  reassign_error: {
    id: `${baseId}.reassign_error`,
    defaultMessage: 'Failed to reassign chat. Please try again.',
  },
  reassign_loading: {
    id: `${baseId}.reassign_loading`,
    defaultMessage: 'Reassigning consultation...',
  },
  reassign_success: {
    id: `${baseId}.reassign_success`,
    defaultMessage: 'Consultation successfully reassigned',
  },
  reassign_success_with_name: {
    id: `${baseId}.reassign_success_with_name`,
    defaultMessage: 'Consultation successfully reassigned to {clinicianName}',
  },
  reassign_no_available_clinicians: {
    id: `${baseId}.reassign_no_available_clinicians`,
    defaultMessage:
      'No available clinicians to reassign this consultation. Please try again later.',
  },
  reassign_dialog_okay: {
    id: `${baseId}.reassign_dialog_okay`,
    defaultMessage: 'Okay',
  },
})
